import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import unitItemListService from './UnitItemListService';

class CreateUnitItemDraftService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      unitItem: null,
    });
    this.form.validations = {
      draftCreationReason: [isRequired],
    };
  }

  init = action(() => {
    this.form.reset();
    this.isOpen = false;
    this.unitItem = null;
  });

  handleShow = action((unitItem) => {
    this.unitItem = unitItem;
    this.isOpen = true;
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.unitItem = null;
    this.form.reset();
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    this.submit
      .fetch({
        method: 'post',
        url: `/units/${this.unitItem.unit}/items/${this.unitItem.item.id}/draft`,
        body: {
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Drat successfully created', 'success');
          unitItemListService.load();
          this.handleClose();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error to create draft', 'error');
        }
      });
  });
}

const createUnitItemDraftService = new CreateUnitItemDraftService();

export default createUnitItemDraftService;
